import { Button, Stack, Box } from "@mui/material";
import { useContext } from "react";
import { FormContext, Form } from "components/shared/Form";
import DictionaryField from "components/ui/atoms/formFields/DictionaryField";
import { ConstantContext } from "components/context/ConstantProvider";

const prepareInitialValues = (object) => ({
  ordering: object?.ordering || null,
});

const NoteSortFormFields = () => {
  const { onSubmit } = useContext(FormContext);
  const { environmentVariables } = useContext(ConstantContext);
  const typesenseEnv = environmentVariables["TYPESENSE_ENV"];
  const sortItems = [
    {
      label: "Newer added",
      value: `${typesenseEnv}_note/sort/created_at:desc`,
    },
    {
      label: "Older added",
      value: `${typesenseEnv}_note/sort/created_at:asc`,
    },
    {
      label: "Newer updated",
      value: `${typesenseEnv}_note/sort/updated_at:desc`,
    },
    {
      label: "Older updated",
      value: `${typesenseEnv}_note/sort/updated_at:asc`,
    },
  ];

  return (
    <Stack spacing={2}>
      <DictionaryField
        optionsDictionary={Object.fromEntries(
          sortItems.map((x) => [x.value, x.label]),
        )}
        name="ordering"
        label="Order by"
      />
      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onSubmit}>
          Apply
        </Button>
      </Box>
    </Stack>
  );
};

const NoteSortForm = (props) => {
  return (
    <Form prepareInitialValues={prepareInitialValues} {...props}>
      <NoteSortFormFields />
    </Form>
  );
};

export default NoteSortForm;
